export enum ServiceLevelType {
  Standard = `Standard`,
  Premium = `Premium`,
}
